import React from 'react';
import { Modal } from 'react-bootstrap';
import { AlertTriangle } from 'lucide-react';

/**
 * Shared confirm modal for the BOOKING tab (cancel-booking, overlap warning).
 * Built on react-bootstrap's Modal — the same component OnsiteSignatureModal
 * and OnsiteChecklistModal already use elsewhere in this app — for native
 * backdrop, elevation, focus trap, and ESC-close instead of reimplementing them.
 * variant="danger": destructive action (cancel). variant="warning": non-destructive
 * heads-up the user can proceed past (overlapping dates).
 */
const ConfirmModal = ({
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  variant = 'danger',
  onConfirm,
  onClose,
}) => {
  return (
    <Modal show onHide={onClose} centered dialogClassName="pbt-modal-dialog">
      <Modal.Body className="pbt-modal-body">
        <div className={`pbt-modal__icon pbt-modal__icon--${variant}`}>
          <AlertTriangle size={20} />
        </div>
        <h5 className="pbt-modal__title">{title}</h5>
        <p className="pbt-modal__message">{message}</p>
      </Modal.Body>
      <Modal.Footer className="pbt-modal__footer">
        <button type="button" className="btn btn-outline-secondary" autoFocus onClick={onClose}>
          {cancelLabel}
        </button>
        <button
          type="button"
          className={`btn ${variant === 'danger' ? 'btn-danger' : 'pbt-btn-book'}`}
          onClick={onConfirm}
        >
          {confirmLabel}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmModal;
